export enum OwnerType {
  USER = 'USER',
  CUSTOMER = 'CUSTOMER',
  OLIASOFT = 'OLIASOFT',
}